var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F1F1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.625H11.25C9 8.625 7.5 9.75 7.5 12.375V17.625C7.5 20.25 9 21.375 11.25 21.375H18.75C21 21.375 22.5 20.25 22.5 17.625V12.375C22.5 9.75 21 8.625 18.75 8.625ZM19.1025 13.1925L16.755 15.0675C16.26 15.465 15.63 15.66 15 15.66C14.37 15.66 13.7325 15.465 13.245 15.0675L10.8975 13.1925C10.6575 12.9975 10.62 12.6375 10.8075 12.3975C11.0025 12.1575 11.355 12.1125 11.595 12.3075L13.9425 14.1825C14.5125 14.64 15.48 14.64 16.05 14.1825L18.3975 12.3075C18.6375 12.1125 18.9975 12.15 19.185 12.3975C19.38 12.6375 19.3425 12.9975 19.1025 13.1925Z",
    fill: "#6E7682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.dc15f909e2f855fd0d204fc4e814f7a8.svg";
export { ForwardRef as ReactComponent };